export const GET_USER = 'GET_USER';
export const USER_PROFILE_LOADED = 'USER_PROFILE_LOADED';
export const CLIENT_LOADED = 'CLIENT_LOADED';
export const GET_CLIENTS = 'GET_CLIENTS';
export const GET_DATA = 'GET_DATA';
export const USER_LOGOUT = 'USER_LOGOUT';

export const DID_REQUEST_INITIAL_DATA = 'DID_REQUEST_INITIAL_DATA';
export const UPDATE_DATA = 'UPDATE_DATA';
export const TOGGLE_SIMULATION = 'TOGGLE_SIMULATION';
export const NEW_SIMULATION = 'NEW_SIMULATION';
export const EXIT_SIMULATION = 'EXIT_SIMULATION';
export const LOAD_SIMULATION = 'LOAD_SIMULATION';
export const SAVE_SIMULATION = 'SAVE_SIMULATION';
export const DELETE_SIMULATION = 'DELETE_SIMULATION';
export const GET_SAVED_SIMULATIONS = 'GET_SAVED_SIMULATIONS';

export const USER_STATUS = 'USER_STATUS';
export const DATA_STATUS = 'GET_DATA';

export const REQUEST_VARIABLE_DATA = 'REQUEST_VARIABLE_DATA';
export const RECEIVE_VARIABLE_DATA = 'RECEIVE_VARIABLE_DATA';

export const RECEIVED_BRAND_DATA = 'RECEIVED_BRAND_DATA';

export const REQUEST_RELEVANCE_DATA = 'REQUEST_RELEVANCE_DATA';
export const RECEIVE_RELEVANCE_DATA = 'RECEIVE_RELEVANCE_DATA';
export const SET_RELEVANCE_GROUP = 'SET_RELEVANCE_GROUP';

export const SET_START_DATE = 'SET_START_DATE';
export const SET_END_DATE = 'SET_END_DATE';
export const TOGGLE_TIMELINE_ACTIVE = 'TOGGLE_TIMELINE_ACTIVE';

export const INIT_TELESCOPE = 'INIT_TELESCOPE';
export const RECEIVED_TELESCOPE_DATA = 'RECEIVED_TELESCOPE_DATA';
export const SET_AVAILABLE_DATES = 'SET_AVAILABLE_DATES';
export const RECEIVED_BRAND_AWARENESS_DATA = 'RECEIVED_BRAND_AWARENESS_DATA';
export const RECEIVED_AD_AWARENESS_DATA = 'RECEIVED_AD_AWARENESS_DATA';
export const RECEIVED_BRAND_CONSIDERATION_DATA = 'RECEIVED_BRAND_CONSIDERATION_DATA';

export const TOGGLE_RELEVANCE_CHART = 'TOGGLE_RELEVANCE_CHART';

export const UPDATE_WASHED_SENTIMENT_DATA = 'UPDATE_WASHED_SENTIMENT_DATA'



// WEBPACK FOOTER //
// ./src/actionTypes.js